<!--注册-->
<template>
  <div id="register">
    <!-- 注册 -->
    <div class="zwcWidth banner">
      <div class="white_box label_box">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">注册账号</div>
          </el-col>
        </el-row>
        <el-form>
          <el-form-item style="margin-bottom: 40px;">
            <el-input placeholder="请输入手机号" v-model="telphone" maxlength="11" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入验证码" style="width: 180px; margin-right: 62px;" maxlength="6" v-model="telCode" clearable></el-input>
            <el-button type="primary" :disabled="d" round :plain="false" @click="smsBtn()" style="border-radius: 0; width: 118px; padding: 12px 0px;">
              <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
              <span v-if="!sendMsgDisabled">发送验证码</span>
            </el-button>
          </el-form-item>
          <el-form-item>
            <p style="font-size: 12px"><span>点击注册账号，表示同意 <span style="color: #35B8DF;cursor: pointer;" @click="tcp('1')">《陪伴玩服务协议》</span>和<span style="color: #35B8DF;cursor: pointer;" @click="tcp('2')">《隐私政策》</span></span></p>
            <p class="enter">
              <el-button type="primary" size="medium" style="" @click="register_btn()">注册账号</el-button>
            </p>
          </el-form-item>
          <!-- 其他选择 -->
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content bg-purple">
                <p style="font-size: 12px">
                  <span class="rt_login" @click="Go_login()">【已有账号,去登录？】</span></p>
              </div>
            </el-col>
          </el-row>

        </el-form>
      </div>
    </div>
    <!--    协议-->
    <tcp :textShow="textShow" :tcpId="tcpId"  ></tcp>
  </div>
</template>


<!--JS-->
<script>
  import tcp from '../../components/common/tcp.vue'
  import {sendSmsToTel,smsCode} from 'api/apis'
  import $ from "jquery";

  export default {
    components:{
      tcp
    },
    data() {
      return {
        telphone: "",
        telCode: "",
        time: 60, // 发送验证码倒计时
        sendMsgDisabled: false,
        d: false, //控制按钮是否禁止点击
        textShow:false,
        tcpId:''
      };
    },
    methods: {
      tcp(id){
        console.log(id)
        this.textShow = !this.textShow
        this.tcpId = id
      },
      Go_login(){
        this.$router.push('/login')
      },

      // 注册
      register_btn() {
        let url = 'param?type=1&url=http://itestm.kandao.com/News/117423'
        localStorage.setItem('appUrl',url)
        let vm = this;
        if (
          vm.telphone == "" ||
          !/^1[34578]\d{9}$/.test(vm.telphone) ||
          vm.telphone.length < 11
        ) {
          vm.$message.error("请输入正确手机号");
          return;
        }
        if (vm.telCode == "" || vm.telCode.length < 6) {
          vm.$message.error("请输入正确验证码");
          return;
        }
        smsCode({ telphone: vm.telphone, address: vm.telCode ,registType:'3'}).then(res => {
            if (res.code == "000000") {
              localStorage.setItem("pbw_user_pc_uid",res.data.uid)
              localStorage.setItem("pbw_user_pc_token",res.data.token)
              vm.$message.success("注册成功，请完善资料");
              vm.$router.push("/userInfo" );
            }else {
              vm.$message.error(res.msg);
            }
          }
        );
      },
      // 发送验证码
      smsBtn() {
        let vm = this;
        console.log("发送");
        //验证码60s
        if (
          vm.telphone == "" ||
          !/^1[34578]\d{9}$/.test(vm.telphone) ||
          vm.telphone.length < 11
        ) {
          vm.$message.error("请输入正确手机号");
          return;
        }


        sendSmsToTel({ 'telphone': this.telphone,'status': '0' }).then(res => {
          if (res.code == "000000") {
            vm.$message.success("短信已发送，请查收");

            vm.sendMsgDisabled = true;
            vm.d = true; //倒计时禁止点击
            let interval = window.setInterval(function() {
              if (vm.time-- <= 0) {
                vm.time = 60;
                vm.sendMsgDisabled = false;
                vm.d = false;
                window.clearInterval(interval);
              }
            }, 1000);
          } else {
            console.log("11111111111111")
            vm.$message.error(res.msg);
          }
        });
      }
    }
  };
</script>


<!--css样式-->
<style lang="scss" scoped>
  @import "../../scss/commonH5.scss";
  .rt_login{
    float: right;
    color: #f60;
  }
  #register {
    text-align: center;
  }
  /* 注册 */
  .banner {
    background: url(../../../static/images/title/login.jpg) no-repeat;
    background-size: 100% 100%;
    width: 100%;
    position: relative;
    height: 640px;
  }
  .banner .white_box {
    background-color: #ffffff;
    width: 365px;
    margin: auto;
    padding: 35px 40px;
    height: 400px;
    position: absolute;
    top: 55px;
    left: 50%;
    border-radius: 10px;
  }
  .white_box .text-title {
    display: inline-block;
    width: 50%;
    text-align: center;
    font-size: 25px;
    float: left;
    box-sizing: border-box;
    cursor: pointer;
  }
  .white_box .text-title.active {
    background-image: -webkit-gradient(
            linear,
            0 0,
            0 bottom,
            from(rgb(252, 96, 12)),
            to(rgb(207, 7, 57))
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .label_box .grid-content {
    cursor: pointer;
    text-align: left;
    font-size: 22px;
    color: #828282;
    margin-bottom: 50px;
  }
</style>





// WEBPACK FOOTER //
// src/views/login/register.vue